import { Bell } from 'lucide-react';

interface NotificationsEmptyProps {
  message?: string;
}

export function NotificationsEmpty({ message = 'Nu ai notificări' }: NotificationsEmptyProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4">
        <Bell className="w-8 h-8 text-gray-400" />
      </div>
      <p className="text-gray-500 text-sm">{message}</p>
    </div>
  );
}
